export const LAYOUT_INJECTION_KEY = 'layout-injection-key';
